import NarratorsBioResultItem from './NarratorsBioResultItem';

export default NarratorsBioResultItem;
